import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FiDownload } from 'react-icons/fi';
import { FaApple } from 'react-icons/fa';

const Download = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <section className="download-section section-container" id="download" ref={ref}>
      <div className="download-glow" />
      <motion.div
        className="download-inner"
        initial={{ opacity: 0, y: 30 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      >
        <span className="section-tag">Yuklab oling</span>
        <h2 className="section-title">
          Hoziroq <span className="gold-text">boshlang</span>
        </h2>
        <p className="section-desc">
          OSTONA ilovasini yuklab oling va orzuingizdagi uyni bugunoq qidirishni boshlang.
          Bepul, qulay va ishonchli.
        </p>
        <div className="download-buttons">
          <a
            href="https://play.google.com/store/apps/details?id=com.ostona.ostona"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-gold"
          >
            <FiDownload /> Android uchun yuklab olish
          </a>
          <button className="btn-outline" disabled style={{ opacity: 0.6 }}>
            <FaApple /> iOS — Tez orada
          </button>
        </div>
        <p style={{ marginTop: 16, fontSize: 13, color: 'rgba(255,255,255,0.5)' }}>
          iOS versiyasi tez orada App Store'ga joylashtiriladi.
        </p>
      </motion.div>
    </section>
  );
};

export default Download;
